<template>
    <PrintEstimator></PrintEstimator>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const PrintEstimator = defineAsyncComponent(() =>
    import(
        "../../components/Decoration/PrintEstimator.vue"
        )
);
export default {
    name: "PrintEstimatorPage",
    components: { PrintEstimator, AuthLayout },
}
</script>
